import * as React from "react";
const SvgWifiOn20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 4a12.952 12.952 0 0 0-8.713 3.352L0 6h-.198C2.478 3.518 6.062 2 10 2c3.938 0 7.522 1.518 10.198 4H20l-1.287 1.352A12.952 12.952 0 0 0 10 4Zm0 2c2.817 0 5.387 1.059 7.333 2.8l-1.38 1.45A8.966 8.966 0 0 0 10 8a8.97 8.97 0 0 0-5.953 2.25L2.667 8.8A10.959 10.959 0 0 1 10 6Zm0 4c1.748 0 3.345.64 4.572 1.7l-1.382 1.45A4.98 4.98 0 0 0 10 12a4.98 4.98 0 0 0-3.19 1.15L5.427 11.7A6.973 6.973 0 0 1 10 10Zm0 7.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgWifiOn20Px;
